import { render } from "./ItemFocReport.vue?vue&type=template&id=525b535e&scoped=true"
import script from "./ItemFocReport.vue?vue&type=script&lang=js"
export * from "./ItemFocReport.vue?vue&type=script&lang=js"

import "./ItemFocReport.vue?vue&type=style&index=0&id=525b535e&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525b535e"]])

export default __exports__